import client from '../helpers/client';

const BASE_URL = 'https://secure.runescape.com/m=hiscore_oldschool/a=13/index_lite.ws';

const getPlayer = (player) => {
  return client.instance(BASE_URL).request({
    method: 'GET',
    params: {
      player
    }
  });
};

export default {
  getPlayer
};
